import { useEffect, useRef, useState } from "react";
import { Avatar, Box, List, ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import Icon from "@mui/material/Icon";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const ListLinks = ({ searchText = "" }) => {
  const links = [
    {
      icon: <Icon fontSize="small">group_add_outlined</Icon>,
      primary: "Clientes",
      secondary: "Gerenciar Clientes",
      to: "/clientes",
    },
    {
      icon: <Icon fontSize="small">swap_horiz</Icon>,
      primary: "Transações",
      secondary: "Gerenciar Transações",
      to: "/transacoes",
    },
    {
      icon: <Icon fontSize="small">group_add_outlined</Icon>,
      primary: "Donos",
      secondary: "Gerenciar Donos",
      to: "/donos",
    },
    {
      icon: <Icon fontSize="small">apartment</Icon>,
      primary: "Imóveis",
      secondary: "Gerenciar Imóveis",
      to: "/imoveis",
    },
    {
      icon: <Icon fontSize="small">apartment</Icon>,
      primary: "Comissões",
      secondary: "Gerenciar Comissões",
      to: "/comissoes",
    },
  ];

  const filteredLinks = searchText
    ? links.filter((link) => link.primary.toLowerCase().includes(searchText.toLowerCase()))
    : [];

  return (
    <List
      sx={{
        width: "100%",
        position: "absolute",
        zIndex: 1000,
        maxWidth: 500,
        bgcolor: "background.paper",
        maxHeight: "200px",
        overflowY: "auto",
      }}
    >
      {filteredLinks.map((link, index) => (
        <ListItem
          sx={{
            bgcolor: "background.paper",
            boxShadow: 3,
            borderRadius: 2,
            p: 2,
            minWidth: 300,
          }}
          component={Link}
          to={link.to}
          key={index}
        >
          <ListItemAvatar>
            <Avatar>{link.icon}</Avatar>
          </ListItemAvatar>
          <ListItemText primary={link.primary} secondary={link.secondary} />
        </ListItem>
      ))}
    </List>
  );
};

ListLinks.propTypes = {
  searchText: PropTypes.text,
};

export default ListLinks;
